class NewsletterArchive {
    constructor() {
              
        this.events(true);
    }

  
    events(data=false) {

        let months = document.querySelectorAll('.iframe-url-js');
        months.forEach(element => {
            element.addEventListener('click', function () {
                months.forEach(btn => btn.classList.remove('is-active'));
                this.classList.add('is-active');
                var iframeUrl =  this.getAttribute('data-url');
                var iframeLinks = document.querySelectorAll('.iframe-wrapper');
                iframeLinks.forEach(source => {
                    source.setAttribute('src', iframeUrl);
                }); 
            });
        });
        
        document.querySelectorAll('.year-tab-btn').forEach( (el) => {
            el.addEventListener('click', (ell) =>  {

                var year =  ell.target.getAttribute('data-year-click');

                var activeBlockElm = document.querySelectorAll('.active-block-'+year);
            
                var abSelectorLength = parseInt( activeBlockElm.length ) - 1;

                if( abSelectorLength > 0 )
                {
                    activeBlockElm[abSelectorLength].classList.add('is-active');
    
                    const select      = document.getElementById('dropdownMenuLink-'+year);
                    var linkTitle     = activeBlockElm[abSelectorLength].getAttribute('title').toUpperCase();
                    console.log(linkTitle);
                    select.innerHTML  = linkTitle;
    
                    var iframeUrl     =  activeBlockElm[abSelectorLength].getAttribute('data-url');
        
                    var iframeLinks = document.querySelectorAll('.iframe-wrapper');
        
                    iframeLinks.forEach(source => {
                        source.setAttribute('src', iframeUrl);
                    }); 
        
                } 
            });
        });

        document.querySelector('.year-tab-btn.active').click();
    }
}
  
export default NewsletterArchive;
new NewsletterArchive();
